export default "__VITE_ASSET__CElnHvdB__"